import { Language } from "./language";

export class EmailSignature {

    constructor(
        public id: number | null,
        public body: string,
        public language: Language
    ){}
}

